import $ from 'jquery'
import scroller from 'scroll'

export default function () {
  const $internalLink = $('[data-internal]')

  $internalLink.on('click', function (e) {
    e.preventDefault()

    const target = $(this).attr('href')
    scrollToElement(target)
  })
}

const getDistance = element => {
  const $element = $(element)
  return $element.offset().top
}

export const scrollToElement = (element, ...options) =>
  scroll(getDistance(element), ...options)

export const scroll = (distance, duration = 1200) => {
  [ document.body, document.documentElement ]
    .forEach(element => {
      scroller.top(element, distance, {
        ease: 'inOutQuint',
        duration
      })
    })
}
